var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo, Children, cloneElement, isValidElement } from "react";
import setRef from "../../../mixins/set-ref";
var getChild = function (children) {
    if (Children.count(children) !== 1)
        return Children.only(children);
    if (isValidElement(children))
        return children;
    return React.createElement("span", null, children);
};
export default (function (children, ref, childProps) {
    return useMemo(function () {
        if (children === undefined || children === null)
            return children;
        if (typeof children === "function") {
            return children(__assign({ ref: function (node) { return setRef(ref, node); } }, childProps));
        }
        var child = getChild(children);
        return cloneElement(child, __assign(__assign({}, childProps), { ref: function (node) {
                setRef(ref, node);
                setRef(child.ref, node);
            } }));
    }, [children, childProps.open]);
});
